import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { QuestionDto } from '@/types/dtos/user/response/question.dto.ts';

export const GET_QUESTIONS_QUERY_KEY = 'get-questions';

export const useGetQuestionsQuery = () => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_QUESTIONS_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      return getQuestions({ token: token ?? '' });
    },
  });
};

const getQuestions = async ({ token }: { token: string }): Promise<QuestionDto[]> => {
  const url = `${import.meta.env.VITE_API_URL}/questions`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
